<script lang="ts">
  import { Popover as PopoverPrimitive } from "bits-ui"
  import { cn, type WithoutChildrenOrChild } from "$lib/utils.js"
  import PopoverPortal from "./popover-portal.svelte"
  import type { ComponentProps } from "svelte"

  let {
    ref = $bindable(null),
    class: className,
    sideOffset = 4,
    align = "center",
    portalProps,
    ...restProps
  }: PopoverPrimitive.ContentProps & {
    portalProps?: WithoutChildrenOrChild<ComponentProps<typeof PopoverPortal>>;
  } = $props()
</script>

<PopoverPortal {...portalProps}>
  <PopoverPrimitive.Content
    bind:ref
    data-slot="popover-content"
    {sideOffset}
    {align}
    class={cn(
			"p-0 flex flex-col gap-4 rounded-md bg-popover text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 z-50 origin-(--transform-origin) outline-hidden",
      align == "center" ? "w-(--bits-popover-anchor-width)" : "",
			className
		)}
    {...restProps}
  />
</PopoverPortal>
